/**
 * These enums are not generated because they are not specified in the OpenAPI specification
 */

export enum PdpStatus {
  Created = 'CREATED',
  ScrapeStarted = 'SCRAPE_STARTED',
  ScrapeDone = 'SCRAPE_DONE',
  Error = 'ERROR',
}

export enum PdpScoreStatus {
  Created = 'CREATED',
  Processing = 'PROCESSING',
  Scored = 'SCORED',
  CategoryNotFound = 'CATEGORY_NOT_FOUND',
  RescorePending = 'RESCORE_PENDING',
  RefreshPending = 'REFRESH_PENDING',
}
